import type React from 'react'
import { useState } from 'react'
// import { useRef, useEffect } from 'react' // TODO: 개발 완료 후 주석 해제
// import { DayPicker } from 'react-day-picker' // TODO: 개발 완료 후 주석 해제
import { Calendar } from 'lucide-react'
// import { ChevronDownIcon } from 'lucide-react' // TODO: 개발 완료 후 주석 해제
import 'react-day-picker/style.css'

interface BirthDateStepProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function BirthDateStep({ value, onChange }: BirthDateStepProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedYear, setSelectedYear] = useState<number | null>(value ? new Date(value).getFullYear() : null)

  // TODO: 개발 완료 후 주석 해제
  // const selectedMonth = 1
  // const [selectedMonth, setSelectedMonth] = useState<number | null>(value ? new Date(value).getMonth() + 1 : null)
  // const [selectedDate, setSelectedDate] = useState<Date | undefined>(value ? new Date(value) : undefined)
  // const [isYearOpen, setIsYearOpen] = useState(false)
  // const [isMonthOpen, setIsMonthOpen] = useState(false)
  // const yearDropdownRef = useRef<HTMLDivElement>(null)
  // const monthDropdownRef = useRef<HTMLDivElement>(null)
  // const yearSelectRef = useRef<HTMLDivElement>(null)
  // const monthSelectRef = useRef<HTMLDivElement>(null)
  // const today = new Date()

  const currentYear = new Date().getFullYear()

  // 100세 제한 - 년도 범위 계산
  const maxYear = currentYear

  // 년도 옵션 생성 (최신년도부터)
  const yearOptions = Array.from({ length: 101 }, (_, i) => maxYear - i)

  // TODO: 개발 완료 후 주석 해제
  // const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  //   value: i + 1,
  //   label: `${i + 1}월`
  // }))

  // TODO: 개발 완료 후 주석 해제 - 외부 클릭 감지
  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     if (
  //       yearDropdownRef.current &&
  //       !yearDropdownRef.current.contains(event.target as Node) &&
  //       yearSelectRef.current &&
  //       !yearSelectRef.current.contains(event.target as Node)
  //     ) {
  //       setIsYearOpen(false)
  //     }
  //     if (
  //       monthDropdownRef.current &&
  //       !monthDropdownRef.current.contains(event.target as Node) &&
  //       monthSelectRef.current &&
  //       !monthSelectRef.current.contains(event.target as Node)
  //     ) {
  //       setIsMonthOpen(false)
  //     }
  //   }
  //   document.addEventListener('mousedown', handleClickOutside)
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside)
  //   }
  // }, [])

  // TODO: 개발 완료 후 복원
  // const handleDateSelect = (date: Date | undefined) => {
  //   setSelectedDate(date)
  //   if (date) {
  //     // 타임존 문제를 해결하기 위해 로컬 시간을 기준으로 포맷팅
  //     const year = date.getFullYear()
  //     const month = String(date.getMonth() + 1).padStart(2, '0')
  //     const day = String(date.getDate()).padStart(2, '0')
  //     const dateString = `${year}-${month}-${day}`
  //     onChange({ target: { value: dateString } } as React.ChangeEvent<HTMLInputElement>)
  //   }
  //   setIsOpen(false)
  // }

  const handleYearSelect = (year: number) => {
    setSelectedYear(year)
    // TODO: 개발 완료 후 원래 로직으로 복원
    // setIsYearOpen(false)
    // 임시: 연도만 받고 월/일은 1월 1일로 고정
    const dateString = `${year}-01-01`
    onChange({ target: { value: dateString } } as React.ChangeEvent<HTMLInputElement>)
    setIsOpen(false)

    // 년도와 월이 모두 선택되면 해당 월의 1일로 설정 // TODO : 개발 완료 후 주석 해제
    // if (selectedMonth) {
    //   const newDate = new Date(year, selectedMonth - 1, 1)
    //   setSelectedDate(newDate)
    // }
  }

  // TODO: 개발 완료 후 주석 해제
  // const handleMonthSelect = (month: number) => {
  //   setSelectedMonth(month)
  //   setIsMonthOpen(false)
  //   if (selectedYear) {
  //     const newDate = new Date(selectedYear, month - 1, 1)
  //     setSelectedDate(newDate)
  //   }
  // }

  // const formatDisplayDate = (date: Date) => {
  //   return date.toLocaleDateString('ko-KR', {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric'
  //   })
  // }

  // const calendarMonth = selectedYear && selectedMonth ? new Date(selectedYear, selectedMonth - 1, 1) : undefined

  // const getMonthNameEn = (month: number) => {
  //   const monthNames = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
  //   return monthNames[month - 1]
  // }

  // 커스텀 캡션 컴포넌트 - "October 1959" 자리에 드롭다운과 네비게이션 통합
  // const CustomCaption = () => (
  //   <div className='absolute top-0 left-0 right-0 flex items-center justify-between h-12 z-10 px-2'>
  //     {/* 왼쪽: 년도/월 드롭다운 */}
  //     <div className='flex items-center gap-2'>
  //       {/* 년도 드롭다운 - "1959" 부분 */}
  //       <div className='relative'>
  //         <div
  //           ref={yearSelectRef}
  //           onClick={() => setIsYearOpen(!isYearOpen)}
  //           className='px-3 py-2 bg-white/70 backdrop-blur-sm transition-all duration-300 text-center text-[18px] font-[600] cursor-pointer flex items-center gap-1'
  //         >
  //           <span className={!selectedYear ? 'text-gray-400' : 'text-gray-800'}>
  //             {selectedYear ? `${selectedYear}년` : '년'}
  //           </span>
  //           <ChevronDownIcon
  //             className={`w-6 h-6 text-gray-400 transition-transform duration-200 ${isYearOpen ? 'rotate-180' : ''}`}
  //           />
  //         </div>

  //         {/* 년도 드롭다운 리스트 */}
  //         {isYearOpen && (
  //           <div
  //             ref={yearDropdownRef}
  //             className='absolute z-20 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto min-w-[100px]'
  //           >
  //             {yearOptions.map(year => (
  //               <div
  //                 key={year}
  //                 onClick={() => handleYearSelect(year)}
  //                 className='px-4 py-2 cursor-pointer border-b border-gray-100 last:border-b-0 hover:bg-gray-50 text-center text-gray-900 font-medium'
  //               >
  //                 {year}
  //               </div>
  //             ))}
  //           </div>
  //         )}
  //       </div>
  //       {/* 월 드롭다운 - "October" 부분 */}
  //       <div className='relative'>
  //         <div
  //           ref={monthSelectRef}
  //           onClick={() => setIsMonthOpen(!isMonthOpen)}
  //           className='px-3 py-2 bg-white/70 backdrop-blur-sm transition-all duration-300 text-center text-[18px] font-[600] cursor-pointer flex items-center gap-1'
  //         >
  //           <span className={!selectedMonth ? 'text-gray-400' : 'text-gray-800'}>
  //             {selectedMonth ? getMonthNameEn(selectedMonth) : '월'}
  //           </span>
  //           <ChevronDownIcon
  //             className={`w-6 h-6 text-gray-400 transition-transform duration-200 ${isMonthOpen ? 'rotate-180' : ''}`}
  //           />
  //         </div>

  //         {/* 월 드롭다운 리스트 */}
  //         {isMonthOpen && (
  //           <div
  //             ref={monthDropdownRef}
  //             className='absolute z-20 left-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto min-w-[140px]'
  //           >
  //             {monthOptions.map(month => (
  //               <div
  //                 key={month.value}
  //                 onClick={() => handleMonthSelect(month.value)}
  //                 className='px-4 py-2 cursor-pointer border-b border-gray-100 last:border-b-0 hover:bg-gray-50 text-left text-gray-900 font-medium'
  //               >
  //                 {getMonthNameEn(month.value)}
  //               </div>
  //             ))}
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // )

  return (
    <>
      {/* 기본 캡션 숨기고 커스텀 스타일 적용 */}
      <style>{`
        .simple-calendar .rdp-day_selected {
          background-color: #FFA236;
          color: white;
        }
        .simple-calendar .rdp-day_today {
          background-color: rgba(255, 162, 54, 0.2);
          color: #FFA236;
        }
        .simple-calendar .rdp-day:hover {
          background-color: rgba(255, 162, 54, 0.1);
        }
        
        /* 기본 캡션 숨기기 */
        .rdp-month_caption {
          visibility: hidden;
          pointer-events: none;
        }
        
        /* 달력 컨테이너에 상대 위치 지정 */
        .calendar-container {
          position: relative;
        }
        .rdp-nav {
          display: none;
        }
        .rdp-day.rdp-selected > .rdp-day_button {
          border: 1px solid #FFA236;
          color: white;
          background-color: #FFA236;
        }
        .rdp-day.rdp-today > .rdp-day_button {
          font-weight: bold;
        }
      `}</style>

      <div className='space-y-4'>
        <div className='space-y-2 mb-6 text-center'>
          {/* TODO: 개발 완료 후 원래 텍스트로 복원 - "생년월일을 알려줄래? 생일이 기다려지네!" */}
          <h2 className='text-[24px] font-[700] text-[#020202]'>
            태어난 연도를 알려줄래?
          </h2>
        </div>

        <div className='relative'>
          {/* GradeStep과 동일한 입력 버튼 */}
          <button
            type='button'
            onClick={() => setIsOpen(!isOpen)}
            className='w-full max-w-[280px] mx-auto text-center text-[18px] font-[500] p-3 rounded-2xl bg-white/70 backdrop-blur-sm border-2 border-[#FFA236]/20 focus:border-[#FFA236] focus:outline-none focus:ring-2 focus:ring-[#FFA236]/50 transition-all duration-300 text-gray-700 hover:border-[#FFA236] flex items-center justify-center gap-3'
          >
            <Calendar className='w-5 h-5 text-[#FFA236]' />
            {/* TODO: 개발 완료 후 원래 로직으로 복원 - selectedDate ? formatDisplayDate(selectedDate) : '날짜를 선택하세요' */}
            <span>{selectedYear ? `${selectedYear}년` : '출생 연도를 선택하세요'}</span>
          </button>

          {/* "October 1959" 자리에 커스텀 드롭다운이 통합된 달력 모달 */}
          {isOpen && (
            <div className='fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4'>
              <div className='bg-white rounded-2xl shadow-xl w-full max-w-sm'>
                {/* 헤더 */}
                <div className='bg-[#FFA236] text-white text-center py-4 rounded-t-2xl'>
                  {/* TODO: 개발 완료 후 "생년월일 선택"으로 복원 */}
                  <h3 className='text-lg font-bold'>출생 연도 선택</h3>
                </div>

                {/* TODO: 개발 완료 후 원래 UI로 복원 - 현재는 연도만 선택 */}
                <div className='p-4'>
                  <div className='max-h-64 overflow-y-auto'>
                    {yearOptions.map(year => (
                      <div
                        key={year}
                        onClick={() => handleYearSelect(year)}
                        className={`px-4 py-3 cursor-pointer border-b border-gray-100 last:border-b-0 hover:bg-amber-50 text-center text-gray-900 font-medium ${selectedYear === year ? 'bg-amber-100 text-amber-700' : ''}`}
                      >
                        {year}년
                      </div>
                    ))}
                  </div>
                </div>
                {/* 원래 달력 UI - TODO: 개발 완료 후 주석 해제
                <div className='p-4'>
                  <div className='calendar-container simple-calendar'>
                    <CustomCaption />
                    <DayPicker
                      mode='single'
                      selected={selectedDate}
                      onSelect={handleDateSelect}
                      month={calendarMonth}
                      disabled={[{ before: new Date(1924, 0, 1) }, { after: today }]}
                      required
                    />
                  </div>
                </div>
                */}

                {/* 닫기 버튼 */}
                <div className='p-4 border-t'>
                  <button
                    type='button'
                    onClick={() => setIsOpen(false)}
                    className='w-full py-2 text-gray-600 hover:text-gray-800 transition-colors'
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
